<template>
<div id="kt_header_mobile" class="kt-header-mobile  kt-header-mobile--fixed ">
    <div class="kt-header-mobile__logo">
        <router-link to="/">
            <img v-if="setting('mobile-logo') !== null"
                alt="Logo"
                :src="setting('mobile-logo')" />
        </router-link>
    </div>
    <div class="kt-header-mobile__toolbar">
        <button class="kt-header-mobile__toolbar-toggler kt-header-mobile__toolbar-toggler--left" id="kt_aside_mobile_toggler"><span></span></button>
        <button class="kt-header-mobile__toolbar-topbar-toggler" id="kt_header_mobile_topbar_toggler"><i class="flaticon-more-1"></i></button>
    </div>
</div>
</template>

<script>
export default {
    methods: {
        setting (slug) {
            return null;
        }
    }
}
</script>

<style>

</style>